var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React, { useContext } from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('page-content-layout');
import { isContentNode } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { MarkdownContent } from '../elements/markdown-content';
export var PageContentLayoutDefaultProps = {
  showIntro: true,
  showOutro: true,
  showContent: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    line-height: 1.45em;\n  "], ["\n    font-size: 1em;\n    line-height: 1.45em;\n  "]))),
  desktopLarge: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IntroStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 1.5em;\n    font-family: ", ";\n    font-weight: 500;\n    line-height: 1.45em;\n    font-size: ", "em;\n    color: ", ";\n  "], ["\n    margin-bottom: 1.5em;\n    font-family: ", ";\n    font-weight: 500;\n    line-height: 1.45em;\n    font-size: ", "em;\n    color: ", ";\n  "])), theme.FONT('serif'), 20 / 16, theme.COLOR('dark'))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: 1em;    \n  "], ["\n    margin-bottom: 1em;    \n  "])))
});
var OutroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: 1em;\n  "], ["\n    margin-bottom: 1em;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Intro: styled(MarkdownContent).attrs(cls.attr('intro'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(MarkdownContent).attrs(cls.attr('content'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Outro: styled(MarkdownContent).attrs(cls.attr('outro'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles)
};
export var PageContentLayout = function PageContentLayout(props) {
  var className = props.className,
      entity = props.entity,
      showOutro = props.showOutro,
      showIntro = props.showIntro,
      showContent = props.showContent,
      beforeIntro = props.beforeIntro,
      beforeContent = props.beforeContent,
      beforeDescription = props.beforeDescription,
      beforeOutro = props.beforeOutro;
  var content = entity.content,
      intro = entity.intro,
      outro = entity.outro,
      description = entity.description;
  var descriptionText = isContentNode(description) ? description.text : description;
  var hasContent = content && !!content.text;
  var hasDescription = !!descriptionText;
  var hasIntro = intro && !!intro.text;
  var hasOutro = outro && !!outro.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, beforeIntro, hasIntro && showIntro && React.createElement(My.Intro, {
    text: intro.text
  }), beforeContent, hasContent && showContent && React.createElement(My.Content, {
    text: content.text
  }), beforeDescription, hasDescription && showContent && React.createElement(My.Content, {
    text: descriptionText
  }), beforeOutro, hasOutro && showOutro && React.createElement(My.Outro, {
    text: outro.text
  }));
};
export var PageContentLayoutContext = React.createContext(PageContentLayout);
export var PageContentLayoutProvider = PageContentLayoutContext.Provider;
export var usePageContentLayout = function usePageContentLayout() {
  return useContext(PageContentLayoutContext);
};
PageContentLayout.defaultProps = PageContentLayoutDefaultProps;
PageContentLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;